import { render, staticRenderFns } from "./SimilaritySmall.vue?vue&type=template&id=7ec56dc4&"
import script from "./SimilaritySmall.vue?vue&type=script&lang=js&"
export * from "./SimilaritySmall.vue?vue&type=script&lang=js&"
import style0 from "./SimilaritySmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports